export type SessionRole = 'admin' | 'team';

export interface StoredSession {
  token: string;
  role: SessionRole;
  teamId: string | null;
}

const sessionKey = 'databinex-arena-session';

export function getStoredSession(): StoredSession | null {
  try {
    const raw = window.localStorage.getItem(sessionKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredSession>;
    if (!parsed.token || (parsed.role !== 'admin' && parsed.role !== 'team')) return null;
    return { token: parsed.token, role: parsed.role, teamId: parsed.teamId ?? null };
  } catch {
    return null;
  }
}

export function setStoredSession(session: StoredSession): void {
  window.localStorage.setItem(sessionKey, JSON.stringify(session));
}

export function clearStoredSession(): void {
  window.localStorage.removeItem(sessionKey);
}
